import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-quick-ref',
    templateUrl: './quick-ref.component.html',
    styleUrls: ['./quick-ref.component.css']
})
export class QuickRefComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
